import * as Yup from 'yup';

const schema = Yup.object().shape({
    contatoEmail: Yup.string().required('O campo deve ser preenchido').email('Informe um email válido'),
});

export default schema;